import { render, staticRenderFns } from "./SettingsGroup.vue?vue&type=template&id=27055f99&scoped=true"
import script from "./SettingsGroup.vue?vue&type=script&lang=js"
export * from "./SettingsGroup.vue?vue&type=script&lang=js"
import style0 from "./SettingsGroup.vue?vue&type=style&index=0&id=27055f99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27055f99",
  null
  
)

export default component.exports